"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AIClients", {
  enumerable: true,
  get: function get() {
    return _AIClients["default"];
  }
});
Object.defineProperty(exports, "Actions", {
  enumerable: true,
  get: function get() {
    return _Actions["default"];
  }
});
Object.defineProperty(exports, "AddPayment", {
  enumerable: true,
  get: function get() {
    return _AddPayment["default"];
  }
});
Object.defineProperty(exports, "AddonEmailMarketing", {
  enumerable: true,
  get: function get() {
    return _AddonEmailMarketing["default"];
  }
});
Object.defineProperty(exports, "AddonPos", {
  enumerable: true,
  get: function get() {
    return _AddonPos["default"];
  }
});
Object.defineProperty(exports, "ArrowBottom", {
  enumerable: true,
  get: function get() {
    return _ArrowBottom["default"];
  }
});
Object.defineProperty(exports, "ArrowLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowRight", {
  enumerable: true,
  get: function get() {
    return _ArrowRight["default"];
  }
});
Object.defineProperty(exports, "ArrowTop", {
  enumerable: true,
  get: function get() {
    return _ArrowTop["default"];
  }
});
Object.defineProperty(exports, "Back", {
  enumerable: true,
  get: function get() {
    return _Back["default"];
  }
});
Object.defineProperty(exports, "Blocked", {
  enumerable: true,
  get: function get() {
    return _Blocked["default"];
  }
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _Calendar["default"];
  }
});
Object.defineProperty(exports, "CalendarCross", {
  enumerable: true,
  get: function get() {
    return _CalendarCross["default"];
  }
});
Object.defineProperty(exports, "CalendarFull", {
  enumerable: true,
  get: function get() {
    return _CalendarFull["default"];
  }
});
Object.defineProperty(exports, "CalendarLine", {
  enumerable: true,
  get: function get() {
    return _CalendarLine["default"];
  }
});
Object.defineProperty(exports, "CalendarShifts", {
  enumerable: true,
  get: function get() {
    return _CalendarShifts["default"];
  }
});
Object.defineProperty(exports, "Car", {
  enumerable: true,
  get: function get() {
    return _Car["default"];
  }
});
Object.defineProperty(exports, "Cart", {
  enumerable: true,
  get: function get() {
    return _Cart["default"];
  }
});
Object.defineProperty(exports, "Cash", {
  enumerable: true,
  get: function get() {
    return _Cash["default"];
  }
});
Object.defineProperty(exports, "Charly", {
  enumerable: true,
  get: function get() {
    return _Charly["default"];
  }
});
Object.defineProperty(exports, "Check", {
  enumerable: true,
  get: function get() {
    return _Check["default"];
  }
});
Object.defineProperty(exports, "CircleBgBottomArrow", {
  enumerable: true,
  get: function get() {
    return _CircleBgBottomArrow["default"];
  }
});
Object.defineProperty(exports, "CircleBgTopArrow", {
  enumerable: true,
  get: function get() {
    return _CircleBgTopArrow["default"];
  }
});
Object.defineProperty(exports, "CircleBottomArrow", {
  enumerable: true,
  get: function get() {
    return _CircleBottomArrow["default"];
  }
});
Object.defineProperty(exports, "CircleCheck", {
  enumerable: true,
  get: function get() {
    return _CircleCheck["default"];
  }
});
Object.defineProperty(exports, "CircleLeftArrow", {
  enumerable: true,
  get: function get() {
    return _CircleLeftArrow["default"];
  }
});
Object.defineProperty(exports, "CirclePrice", {
  enumerable: true,
  get: function get() {
    return _CirclePrice["default"];
  }
});
Object.defineProperty(exports, "CircleQuestion", {
  enumerable: true,
  get: function get() {
    return _CircleQuestion["default"];
  }
});
Object.defineProperty(exports, "CircleRightArrow", {
  enumerable: true,
  get: function get() {
    return _CircleRightArrow["default"];
  }
});
Object.defineProperty(exports, "CircleTopArrow", {
  enumerable: true,
  get: function get() {
    return _CircleTopArrow["default"];
  }
});
Object.defineProperty(exports, "CircleWarning", {
  enumerable: true,
  get: function get() {
    return _CircleWarning["default"];
  }
});
Object.defineProperty(exports, "Client", {
  enumerable: true,
  get: function get() {
    return _Client["default"];
  }
});
Object.defineProperty(exports, "Clock", {
  enumerable: true,
  get: function get() {
    return _Clock["default"];
  }
});
Object.defineProperty(exports, "Close", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});
Object.defineProperty(exports, "CloseLock", {
  enumerable: true,
  get: function get() {
    return _CloseLock["default"];
  }
});
Object.defineProperty(exports, "Combine", {
  enumerable: true,
  get: function get() {
    return _Combine["default"];
  }
});
Object.defineProperty(exports, "Comission", {
  enumerable: true,
  get: function get() {
    return _Comission["default"];
  }
});
Object.defineProperty(exports, "Configuration", {
  enumerable: true,
  get: function get() {
    return _Configuration["default"];
  }
});
Object.defineProperty(exports, "Consent", {
  enumerable: true,
  get: function get() {
    return _Consent["default"];
  }
});
Object.defineProperty(exports, "Contract", {
  enumerable: true,
  get: function get() {
    return _Contract["default"];
  }
});
Object.defineProperty(exports, "Copy", {
  enumerable: true,
  get: function get() {
    return _Copy["default"];
  }
});
Object.defineProperty(exports, "CreditCard", {
  enumerable: true,
  get: function get() {
    return _CreditCard["default"];
  }
});
Object.defineProperty(exports, "Cube", {
  enumerable: true,
  get: function get() {
    return _Cube["default"];
  }
});
Object.defineProperty(exports, "Cursor", {
  enumerable: true,
  get: function get() {
    return _Cursor["default"];
  }
});
Object.defineProperty(exports, "Customization", {
  enumerable: true,
  get: function get() {
    return _Customization["default"];
  }
});
Object.defineProperty(exports, "DebitCard", {
  enumerable: true,
  get: function get() {
    return _DebitCard["default"];
  }
});
Object.defineProperty(exports, "Decrease", {
  enumerable: true,
  get: function get() {
    return _Decrease["default"];
  }
});
Object.defineProperty(exports, "Delete", {
  enumerable: true,
  get: function get() {
    return _Delete["default"];
  }
});
Object.defineProperty(exports, "DeleteUser", {
  enumerable: true,
  get: function get() {
    return _DeleteUser["default"];
  }
});
Object.defineProperty(exports, "DeleteWarning", {
  enumerable: true,
  get: function get() {
    return _DeleteWarning["default"];
  }
});
Object.defineProperty(exports, "Deposit", {
  enumerable: true,
  get: function get() {
    return _Deposit["default"];
  }
});
Object.defineProperty(exports, "Discount", {
  enumerable: true,
  get: function get() {
    return _Discount["default"];
  }
});
Object.defineProperty(exports, "DiscountIcon", {
  enumerable: true,
  get: function get() {
    return _DiscountIcon["default"];
  }
});
Object.defineProperty(exports, "Document", {
  enumerable: true,
  get: function get() {
    return _Document["default"];
  }
});
Object.defineProperty(exports, "DoubleArrowLeft", {
  enumerable: true,
  get: function get() {
    return _DoubleArrowLeft["default"];
  }
});
Object.defineProperty(exports, "DoubleArrowRight", {
  enumerable: true,
  get: function get() {
    return _DoubleArrowRight["default"];
  }
});
Object.defineProperty(exports, "Download", {
  enumerable: true,
  get: function get() {
    return _Download["default"];
  }
});
Object.defineProperty(exports, "Drag", {
  enumerable: true,
  get: function get() {
    return _Drag["default"];
  }
});
Object.defineProperty(exports, "Edit", {
  enumerable: true,
  get: function get() {
    return _Edit["default"];
  }
});
Object.defineProperty(exports, "Email", {
  enumerable: true,
  get: function get() {
    return _Email["default"];
  }
});
Object.defineProperty(exports, "EmailBlacklist", {
  enumerable: true,
  get: function get() {
    return _EmailBlacklist["default"];
  }
});
Object.defineProperty(exports, "EmailConfirmed", {
  enumerable: true,
  get: function get() {
    return _EmailConfirmed["default"];
  }
});
Object.defineProperty(exports, "EmailDelivered", {
  enumerable: true,
  get: function get() {
    return _EmailDelivered["default"];
  }
});
Object.defineProperty(exports, "EmailError", {
  enumerable: true,
  get: function get() {
    return _EmailError["default"];
  }
});
Object.defineProperty(exports, "EmailMarketing", {
  enumerable: true,
  get: function get() {
    return _EmailMarketing["default"];
  }
});
Object.defineProperty(exports, "EmailProgrammed", {
  enumerable: true,
  get: function get() {
    return _EmailProgrammed["default"];
  }
});
Object.defineProperty(exports, "EmailRead", {
  enumerable: true,
  get: function get() {
    return _EmailRead["default"];
  }
});
Object.defineProperty(exports, "EmailSent", {
  enumerable: true,
  get: function get() {
    return _EmailSent["default"];
  }
});
Object.defineProperty(exports, "EmptyState", {
  enumerable: true,
  get: function get() {
    return _EmptyState["default"];
  }
});
Object.defineProperty(exports, "Entry", {
  enumerable: true,
  get: function get() {
    return _Entry["default"];
  }
});
Object.defineProperty(exports, "Envelope", {
  enumerable: true,
  get: function get() {
    return _Envelope["default"];
  }
});
Object.defineProperty(exports, "Equal", {
  enumerable: true,
  get: function get() {
    return _Equal["default"];
  }
});
Object.defineProperty(exports, "ExcelDoc", {
  enumerable: true,
  get: function get() {
    return _ExcelDoc["default"];
  }
});
Object.defineProperty(exports, "Expand", {
  enumerable: true,
  get: function get() {
    return _Expand["default"];
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _Facebook["default"];
  }
});
Object.defineProperty(exports, "Filters", {
  enumerable: true,
  get: function get() {
    return _Filters["default"];
  }
});
Object.defineProperty(exports, "Folder", {
  enumerable: true,
  get: function get() {
    return _Folder["default"];
  }
});
Object.defineProperty(exports, "FolderAdd", {
  enumerable: true,
  get: function get() {
    return _FolderAdd["default"];
  }
});
Object.defineProperty(exports, "Frontdesk", {
  enumerable: true,
  get: function get() {
    return _Frontdesk["default"];
  }
});
Object.defineProperty(exports, "FrontdeskNoEdition", {
  enumerable: true,
  get: function get() {
    return _FrontdeskNoEdition["default"];
  }
});
Object.defineProperty(exports, "GeneralAdmin", {
  enumerable: true,
  get: function get() {
    return _GeneralAdmin["default"];
  }
});
Object.defineProperty(exports, "Gift", {
  enumerable: true,
  get: function get() {
    return _Gift["default"];
  }
});
Object.defineProperty(exports, "GiftCard", {
  enumerable: true,
  get: function get() {
    return _GiftCard["default"];
  }
});
Object.defineProperty(exports, "GiftCardPayment", {
  enumerable: true,
  get: function get() {
    return _GiftCardPayment["default"];
  }
});
Object.defineProperty(exports, "HeatMapChart", {
  enumerable: true,
  get: function get() {
    return _HeatMapChart["default"];
  }
});
Object.defineProperty(exports, "Home", {
  enumerable: true,
  get: function get() {
    return _Home["default"];
  }
});
Object.defineProperty(exports, "Hourglass", {
  enumerable: true,
  get: function get() {
    return _Hourglass["default"];
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _Image["default"];
  }
});
Object.defineProperty(exports, "Increase", {
  enumerable: true,
  get: function get() {
    return _Increase["default"];
  }
});
Object.defineProperty(exports, "Information", {
  enumerable: true,
  get: function get() {
    return _Information["default"];
  }
});
Object.defineProperty(exports, "Instagram", {
  enumerable: true,
  get: function get() {
    return _Instagram["default"];
  }
});
Object.defineProperty(exports, "KebabMenu", {
  enumerable: true,
  get: function get() {
    return _KebabMenu["default"];
  }
});
Object.defineProperty(exports, "LineChart", {
  enumerable: true,
  get: function get() {
    return _LineChart["default"];
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _Link["default"];
  }
});
Object.defineProperty(exports, "LinkedIn", {
  enumerable: true,
  get: function get() {
    return _Linkedin["default"];
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "Loader", {
  enumerable: true,
  get: function get() {
    return _Loader["default"];
  }
});
Object.defineProperty(exports, "LocalAdmin", {
  enumerable: true,
  get: function get() {
    return _LocalAdmin["default"];
  }
});
Object.defineProperty(exports, "Location", {
  enumerable: true,
  get: function get() {
    return _Location["default"];
  }
});
Object.defineProperty(exports, "Marketplace", {
  enumerable: true,
  get: function get() {
    return _Marketplace["default"];
  }
});
Object.defineProperty(exports, "Means", {
  enumerable: true,
  get: function get() {
    return _Means["default"];
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function get() {
    return _Menu["default"];
  }
});
Object.defineProperty(exports, "Metrics", {
  enumerable: true,
  get: function get() {
    return _Metrics["default"];
  }
});
Object.defineProperty(exports, "Minus", {
  enumerable: true,
  get: function get() {
    return _Minus["default"];
  }
});
Object.defineProperty(exports, "MobileArrowBottom", {
  enumerable: true,
  get: function get() {
    return _MobileArrowBottom["default"];
  }
});
Object.defineProperty(exports, "MobileArrowLeft", {
  enumerable: true,
  get: function get() {
    return _MobileArrowLeft["default"];
  }
});
Object.defineProperty(exports, "MobileArrowRight", {
  enumerable: true,
  get: function get() {
    return _MobileArrowRight["default"];
  }
});
Object.defineProperty(exports, "MobileArrowTop", {
  enumerable: true,
  get: function get() {
    return _MobileArrowTop["default"];
  }
});
Object.defineProperty(exports, "More", {
  enumerable: true,
  get: function get() {
    return _More["default"];
  }
});
Object.defineProperty(exports, "MultiplePayments", {
  enumerable: true,
  get: function get() {
    return _MultiplePayments["default"];
  }
});
Object.defineProperty(exports, "New", {
  enumerable: true,
  get: function get() {
    return _New["default"];
  }
});
Object.defineProperty(exports, "NewSale", {
  enumerable: true,
  get: function get() {
    return _NewSale["default"];
  }
});
Object.defineProperty(exports, "NewTab", {
  enumerable: true,
  get: function get() {
    return _NewTab["default"];
  }
});
Object.defineProperty(exports, "NewUser", {
  enumerable: true,
  get: function get() {
    return _NewUser["default"];
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _Notification["default"];
  }
});
Object.defineProperty(exports, "NotificationWithText", {
  enumerable: true,
  get: function get() {
    return _NotificationWithText["default"];
  }
});
Object.defineProperty(exports, "OpenLock", {
  enumerable: true,
  get: function get() {
    return _OpenLock["default"];
  }
});
Object.defineProperty(exports, "Output", {
  enumerable: true,
  get: function get() {
    return _Output["default"];
  }
});
Object.defineProperty(exports, "Pack", {
  enumerable: true,
  get: function get() {
    return _Pack["default"];
  }
});
Object.defineProperty(exports, "Password", {
  enumerable: true,
  get: function get() {
    return _Password["default"];
  }
});
Object.defineProperty(exports, "Pause", {
  enumerable: true,
  get: function get() {
    return _Pause["default"];
  }
});
Object.defineProperty(exports, "Pay", {
  enumerable: true,
  get: function get() {
    return _Pay["default"];
  }
});
Object.defineProperty(exports, "Pdf", {
  enumerable: true,
  get: function get() {
    return _Pdf["default"];
  }
});
Object.defineProperty(exports, "Pendo", {
  enumerable: true,
  get: function get() {
    return _Pendo["default"];
  }
});
Object.defineProperty(exports, "PendoRebranding", {
  enumerable: true,
  get: function get() {
    return _PendoRebranding["default"];
  }
});
Object.defineProperty(exports, "Percentaje", {
  enumerable: true,
  get: function get() {
    return _Percentaje["default"];
  }
});
Object.defineProperty(exports, "Phone", {
  enumerable: true,
  get: function get() {
    return _Phone["default"];
  }
});
Object.defineProperty(exports, "PieChart", {
  enumerable: true,
  get: function get() {
    return _PieChart["default"];
  }
});
Object.defineProperty(exports, "Plan", {
  enumerable: true,
  get: function get() {
    return _Plan["default"];
  }
});
Object.defineProperty(exports, "Plans", {
  enumerable: true,
  get: function get() {
    return _Plans["default"];
  }
});
Object.defineProperty(exports, "Play", {
  enumerable: true,
  get: function get() {
    return _Play["default"];
  }
});
Object.defineProperty(exports, "Plus", {
  enumerable: true,
  get: function get() {
    return _Plus["default"];
  }
});
Object.defineProperty(exports, "PlusCircle", {
  enumerable: true,
  get: function get() {
    return _PlusCircle["default"];
  }
});
Object.defineProperty(exports, "Pos", {
  enumerable: true,
  get: function get() {
    return _Pos["default"];
  }
});
Object.defineProperty(exports, "Premium", {
  enumerable: true,
  get: function get() {
    return _Premium["default"];
  }
});
Object.defineProperty(exports, "PreviousView", {
  enumerable: true,
  get: function get() {
    return _PreviousView["default"];
  }
});
Object.defineProperty(exports, "Price", {
  enumerable: true,
  get: function get() {
    return _Price["default"];
  }
});
Object.defineProperty(exports, "Print", {
  enumerable: true,
  get: function get() {
    return _Print["default"];
  }
});
Object.defineProperty(exports, "Profile", {
  enumerable: true,
  get: function get() {
    return _Profile["default"];
  }
});
Object.defineProperty(exports, "Puzzle", {
  enumerable: true,
  get: function get() {
    return _Puzzle["default"];
  }
});
Object.defineProperty(exports, "Question", {
  enumerable: true,
  get: function get() {
    return _Question["default"];
  }
});
Object.defineProperty(exports, "QuickPayment", {
  enumerable: true,
  get: function get() {
    return _QuickPayment["default"];
  }
});
Object.defineProperty(exports, "Reactivate", {
  enumerable: true,
  get: function get() {
    return _Reactivate["default"];
  }
});
Object.defineProperty(exports, "ReadMore", {
  enumerable: true,
  get: function get() {
    return _ReadMore["default"];
  }
});
Object.defineProperty(exports, "RebrandingProviders", {
  enumerable: true,
  get: function get() {
    return _RebrandingProviders["default"];
  }
});
Object.defineProperty(exports, "RebrandingWhatsapp", {
  enumerable: true,
  get: function get() {
    return _RebrandingWhatsapp["default"];
  }
});
Object.defineProperty(exports, "Recharge", {
  enumerable: true,
  get: function get() {
    return _Recharge["default"];
  }
});
Object.defineProperty(exports, "ReservationStatus", {
  enumerable: true,
  get: function get() {
    return _ReservationStatus["default"];
  }
});
Object.defineProperty(exports, "SavePayment", {
  enumerable: true,
  get: function get() {
    return _SavePayment["default"];
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _Search["default"];
  }
});
Object.defineProperty(exports, "Search2", {
  enumerable: true,
  get: function get() {
    return _Search2["default"];
  }
});
Object.defineProperty(exports, "SeeMap", {
  enumerable: true,
  get: function get() {
    return _SeeMap["default"];
  }
});
Object.defineProperty(exports, "Send", {
  enumerable: true,
  get: function get() {
    return _Send["default"];
  }
});
Object.defineProperty(exports, "Service", {
  enumerable: true,
  get: function get() {
    return _Service["default"];
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function get() {
    return _Share["default"];
  }
});
Object.defineProperty(exports, "SidebarCommissions", {
  enumerable: true,
  get: function get() {
    return _SidebarCommissions["default"];
  }
});
Object.defineProperty(exports, "SidebarPlans", {
  enumerable: true,
  get: function get() {
    return _SidebarPlans["default"];
  }
});
Object.defineProperty(exports, "SidebarProviders", {
  enumerable: true,
  get: function get() {
    return _SidebarProviders["default"];
  }
});
Object.defineProperty(exports, "SidebarResources", {
  enumerable: true,
  get: function get() {
    return _SidebarResources["default"];
  }
});
Object.defineProperty(exports, "SidebarShifts", {
  enumerable: true,
  get: function get() {
    return _SidebarShifts["default"];
  }
});
Object.defineProperty(exports, "SidebarSurveys", {
  enumerable: true,
  get: function get() {
    return _SidebarSurveys["default"];
  }
});
Object.defineProperty(exports, "SignedConsent", {
  enumerable: true,
  get: function get() {
    return _SignedConsent["default"];
  }
});
Object.defineProperty(exports, "Sms", {
  enumerable: true,
  get: function get() {
    return _Sms["default"];
  }
});
Object.defineProperty(exports, "SolidStar", {
  enumerable: true,
  get: function get() {
    return _SolidStar["default"];
  }
});
Object.defineProperty(exports, "Sort", {
  enumerable: true,
  get: function get() {
    return _Sort["default"];
  }
});
Object.defineProperty(exports, "Staff", {
  enumerable: true,
  get: function get() {
    return _Staff["default"];
  }
});
Object.defineProperty(exports, "StaffNoEdition", {
  enumerable: true,
  get: function get() {
    return _StaffNoEdition["default"];
  }
});
Object.defineProperty(exports, "Star", {
  enumerable: true,
  get: function get() {
    return _Star["default"];
  }
});
Object.defineProperty(exports, "StarGroup", {
  enumerable: true,
  get: function get() {
    return _StarGroup["default"];
  }
});
Object.defineProperty(exports, "Stop", {
  enumerable: true,
  get: function get() {
    return _Stop["default"];
  }
});
Object.defineProperty(exports, "Store", {
  enumerable: true,
  get: function get() {
    return _Store["default"];
  }
});
Object.defineProperty(exports, "Survey", {
  enumerable: true,
  get: function get() {
    return _Survey["default"];
  }
});
Object.defineProperty(exports, "Telegram", {
  enumerable: true,
  get: function get() {
    return _Telegram["default"];
  }
});
Object.defineProperty(exports, "Transfer", {
  enumerable: true,
  get: function get() {
    return _Transfer["default"];
  }
});
Object.defineProperty(exports, "TriangleWarning", {
  enumerable: true,
  get: function get() {
    return _TriangleWarning["default"];
  }
});
Object.defineProperty(exports, "TurnOn", {
  enumerable: true,
  get: function get() {
    return _TurnOn["default"];
  }
});
Object.defineProperty(exports, "Undo", {
  enumerable: true,
  get: function get() {
    return _Undo["default"];
  }
});
Object.defineProperty(exports, "UpTrend", {
  enumerable: true,
  get: function get() {
    return _UpTrend["default"];
  }
});
Object.defineProperty(exports, "Upload", {
  enumerable: true,
  get: function get() {
    return _Upload["default"];
  }
});
Object.defineProperty(exports, "UploadFile", {
  enumerable: true,
  get: function get() {
    return _UploadFile["default"];
  }
});
Object.defineProperty(exports, "UploadImg", {
  enumerable: true,
  get: function get() {
    return _UploadImg["default"];
  }
});
Object.defineProperty(exports, "UploadedDoc", {
  enumerable: true,
  get: function get() {
    return _UploadedDoc["default"];
  }
});
Object.defineProperty(exports, "UserBgCollapse", {
  enumerable: true,
  get: function get() {
    return _UserBgCollapse["default"];
  }
});
Object.defineProperty(exports, "UserBgExpand", {
  enumerable: true,
  get: function get() {
    return _UserBgExpand["default"];
  }
});
Object.defineProperty(exports, "UserDocument", {
  enumerable: true,
  get: function get() {
    return _UserDocument["default"];
  }
});
Object.defineProperty(exports, "Users", {
  enumerable: true,
  get: function get() {
    return _Users["default"];
  }
});
Object.defineProperty(exports, "VideoCall", {
  enumerable: true,
  get: function get() {
    return _VideoCall["default"];
  }
});
Object.defineProperty(exports, "View", {
  enumerable: true,
  get: function get() {
    return _View["default"];
  }
});
Object.defineProperty(exports, "ViewLocked", {
  enumerable: true,
  get: function get() {
    return _ViewLocked["default"];
  }
});
Object.defineProperty(exports, "WarehouseKeeper", {
  enumerable: true,
  get: function get() {
    return _WarehouseKeeper["default"];
  }
});
Object.defineProperty(exports, "Website", {
  enumerable: true,
  get: function get() {
    return _Website["default"];
  }
});
Object.defineProperty(exports, "WebsiteMessage", {
  enumerable: true,
  get: function get() {
    return _WebsiteMessage["default"];
  }
});
Object.defineProperty(exports, "WebsiteNotification", {
  enumerable: true,
  get: function get() {
    return _WebsiteNotification["default"];
  }
});
Object.defineProperty(exports, "Whatsapp", {
  enumerable: true,
  get: function get() {
    return _Whatsapp["default"];
  }
});
Object.defineProperty(exports, "WhatsappConfirmed", {
  enumerable: true,
  get: function get() {
    return _WhatsappConfirmed["default"];
  }
});
Object.defineProperty(exports, "WhatsappDelivered", {
  enumerable: true,
  get: function get() {
    return _WhatsappDelivered["default"];
  }
});
Object.defineProperty(exports, "WhatsappError", {
  enumerable: true,
  get: function get() {
    return _WhatsappError["default"];
  }
});
Object.defineProperty(exports, "WhatsappProgrammed", {
  enumerable: true,
  get: function get() {
    return _WhatsappProgrammed["default"];
  }
});
Object.defineProperty(exports, "WhatsappRead", {
  enumerable: true,
  get: function get() {
    return _WhatsappRead["default"];
  }
});
Object.defineProperty(exports, "WhatsappSent", {
  enumerable: true,
  get: function get() {
    return _WhatsappSent["default"];
  }
});
Object.defineProperty(exports, "Youtube", {
  enumerable: true,
  get: function get() {
    return _Youtube["default"];
  }
});
var _Actions = _interopRequireDefault(require("./Actions"));
var _AddPayment = _interopRequireDefault(require("./AddPayment"));
var _AIClients = _interopRequireDefault(require("./AIClients"));
var _ArrowBottom = _interopRequireDefault(require("./ArrowBottom"));
var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));
var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));
var _ArrowTop = _interopRequireDefault(require("./ArrowTop"));
var _Back = _interopRequireDefault(require("./Back"));
var _Blocked = _interopRequireDefault(require("./Blocked"));
var _Calendar = _interopRequireDefault(require("./Calendar"));
var _CalendarCross = _interopRequireDefault(require("./CalendarCross"));
var _CalendarFull = _interopRequireDefault(require("./CalendarFull"));
var _CalendarLine = _interopRequireDefault(require("./CalendarLine"));
var _CalendarShifts = _interopRequireDefault(require("./CalendarShifts"));
var _Car = _interopRequireDefault(require("./Car"));
var _Cart = _interopRequireDefault(require("./Cart"));
var _Cash = _interopRequireDefault(require("./Cash"));
var _Charly = _interopRequireDefault(require("./Charly"));
var _Check = _interopRequireDefault(require("./Check"));
var _CircleBgBottomArrow = _interopRequireDefault(require("./CircleBgBottomArrow"));
var _CircleBgTopArrow = _interopRequireDefault(require("./CircleBgTopArrow"));
var _CircleBottomArrow = _interopRequireDefault(require("./CircleBottomArrow"));
var _CircleCheck = _interopRequireDefault(require("./CircleCheck"));
var _CircleLeftArrow = _interopRequireDefault(require("./CircleLeftArrow"));
var _CirclePrice = _interopRequireDefault(require("./CirclePrice"));
var _CircleQuestion = _interopRequireDefault(require("./CircleQuestion"));
var _CircleRightArrow = _interopRequireDefault(require("./CircleRightArrow"));
var _CircleTopArrow = _interopRequireDefault(require("./CircleTopArrow"));
var _CircleWarning = _interopRequireDefault(require("./CircleWarning"));
var _Client = _interopRequireDefault(require("./Client"));
var _Clock = _interopRequireDefault(require("./Clock"));
var _Close = _interopRequireDefault(require("./Close"));
var _CloseLock = _interopRequireDefault(require("./CloseLock"));
var _Combine = _interopRequireDefault(require("./Combine"));
var _Comission = _interopRequireDefault(require("./Comission"));
var _Configuration = _interopRequireDefault(require("./Configuration"));
var _Consent = _interopRequireDefault(require("./Consent"));
var _Contract = _interopRequireDefault(require("./Contract"));
var _Copy = _interopRequireDefault(require("./Copy"));
var _CreditCard = _interopRequireDefault(require("./CreditCard"));
var _Cube = _interopRequireDefault(require("./Cube"));
var _Cursor = _interopRequireDefault(require("./Cursor"));
var _Customization = _interopRequireDefault(require("./Customization"));
var _DebitCard = _interopRequireDefault(require("./DebitCard"));
var _Decrease = _interopRequireDefault(require("./Decrease"));
var _Delete = _interopRequireDefault(require("./Delete"));
var _DeleteUser = _interopRequireDefault(require("./DeleteUser"));
var _DeleteWarning = _interopRequireDefault(require("./DeleteWarning"));
var _Deposit = _interopRequireDefault(require("./Deposit"));
var _Discount = _interopRequireDefault(require("./Discount"));
var _DiscountIcon = _interopRequireDefault(require("./DiscountIcon"));
var _Document = _interopRequireDefault(require("./Document"));
var _DoubleArrowLeft = _interopRequireDefault(require("./DoubleArrowLeft"));
var _DoubleArrowRight = _interopRequireDefault(require("./DoubleArrowRight"));
var _Download = _interopRequireDefault(require("./Download"));
var _Drag = _interopRequireDefault(require("./Drag"));
var _Edit = _interopRequireDefault(require("./Edit"));
var _Email = _interopRequireDefault(require("./Email"));
var _EmailBlacklist = _interopRequireDefault(require("./EmailBlacklist"));
var _EmailMarketing = _interopRequireDefault(require("./EmailMarketing"));
var _EmailProgrammed = _interopRequireDefault(require("./EmailProgrammed"));
var _EmailSent = _interopRequireDefault(require("./EmailSent"));
var _EmailDelivered = _interopRequireDefault(require("./EmailDelivered"));
var _EmailRead = _interopRequireDefault(require("./EmailRead"));
var _EmailError = _interopRequireDefault(require("./EmailError"));
var _EmailConfirmed = _interopRequireDefault(require("./EmailConfirmed"));
var _Entry = _interopRequireDefault(require("./Entry"));
var _Envelope = _interopRequireDefault(require("./Envelope"));
var _Equal = _interopRequireDefault(require("./Equal"));
var _ExcelDoc = _interopRequireDefault(require("./ExcelDoc"));
var _Expand = _interopRequireDefault(require("./Expand"));
var _Facebook = _interopRequireDefault(require("./Facebook"));
var _Filters = _interopRequireDefault(require("./Filters"));
var _Folder = _interopRequireDefault(require("./Folder"));
var _FolderAdd = _interopRequireDefault(require("./FolderAdd"));
var _Frontdesk = _interopRequireDefault(require("./Frontdesk"));
var _FrontdeskNoEdition = _interopRequireDefault(require("./FrontdeskNoEdition"));
var _GeneralAdmin = _interopRequireDefault(require("./GeneralAdmin"));
var _Gift = _interopRequireDefault(require("./Gift"));
var _GiftCard = _interopRequireDefault(require("./GiftCard"));
var _GiftCardPayment = _interopRequireDefault(require("./GiftCardPayment"));
var _HeatMapChart = _interopRequireDefault(require("./HeatMapChart"));
var _Home = _interopRequireDefault(require("./Home"));
var _Hourglass = _interopRequireDefault(require("./Hourglass"));
var _Image = _interopRequireDefault(require("./Image"));
var _Increase = _interopRequireDefault(require("./Increase"));
var _Information = _interopRequireDefault(require("./Information"));
var _Instagram = _interopRequireDefault(require("./Instagram"));
var _KebabMenu = _interopRequireDefault(require("./KebabMenu"));
var _LineChart = _interopRequireDefault(require("./LineChart"));
var _Link = _interopRequireDefault(require("./Link"));
var _Linkedin = _interopRequireDefault(require("./Linkedin"));
var _List = _interopRequireDefault(require("./List"));
var _Loader = _interopRequireDefault(require("./Loader"));
var _LocalAdmin = _interopRequireDefault(require("./LocalAdmin"));
var _Location = _interopRequireDefault(require("./Location"));
var _Means = _interopRequireDefault(require("./Means"));
var _Menu = _interopRequireDefault(require("./Menu"));
var _Metrics = _interopRequireDefault(require("./Metrics"));
var _Minus = _interopRequireDefault(require("./Minus"));
var _MobileArrowBottom = _interopRequireDefault(require("./MobileArrowBottom"));
var _MobileArrowLeft = _interopRequireDefault(require("./MobileArrowLeft"));
var _MobileArrowRight = _interopRequireDefault(require("./MobileArrowRight"));
var _MobileArrowTop = _interopRequireDefault(require("./MobileArrowTop"));
var _More = _interopRequireDefault(require("./More"));
var _MultiplePayments = _interopRequireDefault(require("./MultiplePayments"));
var _New = _interopRequireDefault(require("./New"));
var _NewSale = _interopRequireDefault(require("./NewSale"));
var _NewTab = _interopRequireDefault(require("./NewTab"));
var _NewUser = _interopRequireDefault(require("./NewUser"));
var _Notification = _interopRequireDefault(require("./Notification"));
var _NotificationWithText = _interopRequireDefault(require("./NotificationWithText"));
var _OpenLock = _interopRequireDefault(require("./OpenLock"));
var _Output = _interopRequireDefault(require("./Output"));
var _Pack = _interopRequireDefault(require("./Pack"));
var _Pause = _interopRequireDefault(require("./Pause"));
var _Pay = _interopRequireDefault(require("./Pay"));
var _Password = _interopRequireDefault(require("./Password"));
var _Pdf = _interopRequireDefault(require("./Pdf"));
var _Pendo = _interopRequireDefault(require("./Pendo"));
var _PendoRebranding = _interopRequireDefault(require("./PendoRebranding"));
var _Percentaje = _interopRequireDefault(require("./Percentaje"));
var _Phone = _interopRequireDefault(require("./Phone"));
var _PieChart = _interopRequireDefault(require("./PieChart"));
var _Plan = _interopRequireDefault(require("./Plan"));
var _Plans = _interopRequireDefault(require("./Plans"));
var _Play = _interopRequireDefault(require("./Play"));
var _Plus = _interopRequireDefault(require("./Plus"));
var _Pos = _interopRequireDefault(require("./Pos"));
var _Premium = _interopRequireDefault(require("./Premium"));
var _PreviousView = _interopRequireDefault(require("./PreviousView"));
var _Price = _interopRequireDefault(require("./Price"));
var _Print = _interopRequireDefault(require("./Print"));
var _Profile = _interopRequireDefault(require("./Profile"));
var _Puzzle = _interopRequireDefault(require("./Puzzle"));
var _Question = _interopRequireDefault(require("./Question"));
var _Reactivate = _interopRequireDefault(require("./Reactivate"));
var _ReadMore = _interopRequireDefault(require("./ReadMore"));
var _RebrandingProviders = _interopRequireDefault(require("./RebrandingProviders"));
var _RebrandingWhatsapp = _interopRequireDefault(require("./RebrandingWhatsapp"));
var _Recharge = _interopRequireDefault(require("./Recharge"));
var _ReservationStatus = _interopRequireDefault(require("./ReservationStatus"));
var _SavePayment = _interopRequireDefault(require("./SavePayment"));
var _Search = _interopRequireDefault(require("./Search"));
var _Search2 = _interopRequireDefault(require("./Search2"));
var _SeeMap = _interopRequireDefault(require("./SeeMap"));
var _Send = _interopRequireDefault(require("./Send"));
var _Service = _interopRequireDefault(require("./Service"));
var _Share = _interopRequireDefault(require("./Share"));
var _SidebarCommissions = _interopRequireDefault(require("./SidebarCommissions"));
var _SidebarPlans = _interopRequireDefault(require("./SidebarPlans"));
var _SidebarProviders = _interopRequireDefault(require("./SidebarProviders"));
var _SidebarResources = _interopRequireDefault(require("./SidebarResources"));
var _SidebarShifts = _interopRequireDefault(require("./SidebarShifts"));
var _SidebarSurveys = _interopRequireDefault(require("./SidebarSurveys"));
var _SignedConsent = _interopRequireDefault(require("./SignedConsent"));
var _Sms = _interopRequireDefault(require("./Sms"));
var _SolidStar = _interopRequireDefault(require("./SolidStar"));
var _Sort = _interopRequireDefault(require("./Sort"));
var _Staff = _interopRequireDefault(require("./Staff"));
var _StaffNoEdition = _interopRequireDefault(require("./StaffNoEdition"));
var _Star = _interopRequireDefault(require("./Star"));
var _StarGroup = _interopRequireDefault(require("./StarGroup"));
var _Stop = _interopRequireDefault(require("./Stop"));
var _Store = _interopRequireDefault(require("./Store"));
var _Survey = _interopRequireDefault(require("./Survey"));
var _Transfer = _interopRequireDefault(require("./Transfer"));
var _TriangleWarning = _interopRequireDefault(require("./TriangleWarning"));
var _TurnOn = _interopRequireDefault(require("./TurnOn"));
var _Undo = _interopRequireDefault(require("./Undo"));
var _Upload = _interopRequireDefault(require("./Upload"));
var _UploadedDoc = _interopRequireDefault(require("./UploadedDoc"));
var _UploadFile = _interopRequireDefault(require("./UploadFile"));
var _UploadImg = _interopRequireDefault(require("./UploadImg"));
var _UpTrend = _interopRequireDefault(require("./UpTrend"));
var _UserBgCollapse = _interopRequireDefault(require("./UserBgCollapse"));
var _UserBgExpand = _interopRequireDefault(require("./UserBgExpand"));
var _UserDocument = _interopRequireDefault(require("./UserDocument"));
var _Users = _interopRequireDefault(require("./Users"));
var _VideoCall = _interopRequireDefault(require("./VideoCall"));
var _View = _interopRequireDefault(require("./View"));
var _ViewLocked = _interopRequireDefault(require("./ViewLocked"));
var _Website = _interopRequireDefault(require("./Website"));
var _WebsiteMessage = _interopRequireDefault(require("./WebsiteMessage"));
var _WebsiteNotification = _interopRequireDefault(require("./WebsiteNotification"));
var _Whatsapp = _interopRequireDefault(require("./Whatsapp"));
var _WhatsappSent = _interopRequireDefault(require("./WhatsappSent"));
var _WhatsappRead = _interopRequireDefault(require("./WhatsappRead"));
var _WhatsappDelivered = _interopRequireDefault(require("./WhatsappDelivered"));
var _WhatsappError = _interopRequireDefault(require("./WhatsappError"));
var _WhatsappConfirmed = _interopRequireDefault(require("./WhatsappConfirmed"));
var _WhatsappProgrammed = _interopRequireDefault(require("./WhatsappProgrammed"));
var _Youtube = _interopRequireDefault(require("./Youtube"));
var _AddonPos = _interopRequireDefault(require("./AddonPos"));
var _PlusCircle = _interopRequireDefault(require("./PlusCircle"));
var _AddonEmailMarketing = _interopRequireDefault(require("./AddonEmailMarketing"));
var _WarehouseKeeper = _interopRequireDefault(require("./WarehouseKeeper"));
var _Marketplace = _interopRequireDefault(require("./Marketplace"));
var _QuickPayment = _interopRequireDefault(require("./QuickPayment"));
var _Telegram = _interopRequireDefault(require("./Telegram"));
var _EmptyState = _interopRequireDefault(require("./EmptyState"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }